import { ThemeProvider } from '../../providers/theme';
import { SelectProvider } from '../../providers/selectedContext';
import { CorrelationProvider } from '../../providers/Correlation';
import { MultiAnalysisProvider } from '../../providers/MultiAnalysis';
import { AutoCorrelationProvider } from '../../providers/AutoCorrelation';
import { NotificationCenterProvider } from '../../providers/NotificationCenter';
import ProtectedRoute from '../ProtectedRoute';

const AppLayout = () => (
  <ThemeProvider>
    <SelectProvider>
      <CorrelationProvider>
        <MultiAnalysisProvider>
          <AutoCorrelationProvider>
            <NotificationCenterProvider>
              <ProtectedRoute />
            </NotificationCenterProvider>
          </AutoCorrelationProvider>
        </MultiAnalysisProvider>
      </CorrelationProvider>
    </SelectProvider>
  </ThemeProvider>
);

export default AppLayout;
